import { ClientsClient } from '@src/clients/services/ClientsClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRevalidator } from 'react-router-dom';

interface Props {
  clientId: string;
  onSuccess: () => void;
  onError: () => void;
}

export const useUnarchiveClient = ({ clientId, onSuccess, onError }: Props) => {
  const queryClient = useQueryClient();
  const revalidator = useRevalidator();

  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      await ClientsClient.unarchive(clientId);
    },
    onSuccess: async () => {
      onSuccess();
      await queryClient.refetchQueries({
        queryKey: ['clients.list'],
      });
      revalidator.revalidate();
    },
    onError,
  });

  return {
    unarchiveClient: mutate,
    isLoading: isPending,
  };
};
